import { useNavigate } from "react-router-dom";
import { Fragment } from "react";
import { toast } from 'react-toastify';

import Tab, { TabProps } from "../../../molecules/Tab";

import PageForm from "../../../templates/PageForm";
import { computed, useSignal } from "@preact/signals-react";
import { ErrorField } from "../../../../types/ErrorField";

import { removeErrorField } from "../../../../utils/formErrorUtils";
import IndividualFormTab1 from "./IndividualFormTab1";
import { storage } from "../../../../utils/storage";
import appConfig from "../../../../config/app-config";

const { address: PERSON_API_URL, key: PERSON_API_KEY } = appConfig.apis.personApiEnv;
const BASE_URL = `${PERSON_API_URL}/individual`;

type Form = {
    socialId: string;
    name: string;
    mobilePhone: string;
    email: string;
    phone: string;
    isNationalNumber: string;
}

const IndividualPageForm = () => {


    const navigate = useNavigate();
    const isSendingForm = useSignal<boolean>(false);
    const errorFields = useSignal<ErrorField[]>([]);
    const apiVersion = useSignal('');
    const isLoadingForm = useSignal<boolean>(false);

    const form = useSignal<Form>({
        socialId: '',
        name: '',
        mobilePhone: '',
        email: '',
        phone: '',
        isNationalNumber: '1'
    });

    const tabItems: TabProps[] = [
        { id: "tab-1", title: 'Dados basicos', index: 0 },

    ];




    const cancelForm = () => {
        // Usar estado persistido ou fallback para padrão DESC
        const listState = storage.getIndividualListState();
        const filters = storage.getIndividualFilters();
        const { page, pageSize, field, order } = listState;
        const { txtNameSocialId, txtEmail, txtMobile } = filters;

        const url = `/individual/individual-list/${page}/${pageSize}/${field}/${order}/p=${txtNameSocialId};r=${txtMobile};s=${txtEmail};`;
        navigate(url);
    };

    const submitForm = async () => {
        isSendingForm.value = true;

        try {
            const token = localStorage.getItem('authToken');


            let sendForm: Form = {
                socialId: form.value.socialId.replace(/[^0-9]/g, ""),
                name: form.value.name,
                mobilePhone: form.value.mobilePhone.replace(/[^0-9]/g, ""),
                email: form.value.email,
                phone: form.value.phone.replace(/[^0-9]/g, ""),
                isNationalNumber: form.value.isNationalNumber
            };

            if (sendForm.mobilePhone && sendForm.phone && sendForm.mobilePhone === sendForm.phone) {
                toast.error("Os números de celular e telefone não podem ser iguais.");
                isSendingForm.value = false;
                return;
            }

            const response = await fetch(`${BASE_URL}`, {
                method: 'POST',
                headers: {
                    'x-api-key': PERSON_API_KEY || '',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(sendForm),
            });

            if (response.ok) {
                toast.success('Pessoa cadastrada com sucesso!');
                // Sempre redirecionar para listagem de PFs
                const listState = storage.getIndividualListState();
                const filters = storage.getIndividualFilters();
                const { page, pageSize, field, order } = listState;
                const { txtNameSocialId, txtEmail, txtMobile } = filters;

                const url = `/individual/individual-list/${page}/${pageSize}/${field}/${order}/p=${txtNameSocialId};r=${txtMobile};s=${txtEmail};`;
                navigate(url);
            } else if (response.status === 401) {
                toast.error('A sessão expirou. Faça login novamente.');
                navigate('/login');
            } else if (response.status === 409) {
                const { errors, message } = await response.json();
                toast.error(message);
                errorFields.value = errors ? errors.map((error: any) => ({ fieldName: error.field, message: error.message })) : [];
            } else {
                toast.error("Ocorreu um erro na comunicação com o servidor!\nTente novamente mais tarde.");
            }
        } catch (error) {
            toast.error("Ocorreu um erro na comunicação com o servidor!\nTente novamente mais tarde.");
        }
        isSendingForm.value = false;
    };


    const saveButtonDisable = computed(() => {
        return (isSendingForm.value || form.value.socialId === '' ||
            form.value.name === '');
    });

    const changeForm = (field: string, value: string) => {
        form.value = {
            ...form.value,
            [field]: value,
        };
        removeErrorField(errorFields.value, field);
    };

    return (
        <PageForm
            pageTitle={"Nova PF"}
            apiVersion={apiVersion.value}
            isLoading={isSendingForm.value || isLoadingForm.value}
            breadcrumb={[
                {
                    label: "Listagem de pessoas físicas",
                    url: (() => {
                        const listState = storage.getIndividualListState();
                        const filters = storage.getIndividualFilters();
                        const { page, pageSize, field, order } = listState;
                        const { txtNameSocialId, txtEmail, txtMobile } = filters;
                        return `/individual/individual-list/${page}/${pageSize}/${field}/${order}/p=${txtNameSocialId};r=${txtMobile};s=${txtEmail};`;
                    })()
                },
                { label: "Nova PF", url: "#" },
            ]}
            controlSlot={(
                <div className="flex space-x-4 justify-end m-2">
                    <button
                        id="btn-cancel-individual"
                        className='text-black bg-slate-200 px-4 py-2 hover:bg-slate-400 rounded'
                        onClick={cancelForm}
                        title="Cancelar registro"
                        disabled={isSendingForm.value}
                    >
                        Cancelar
                    </button>
                    <button
                        id="btn-advance-individual"
                        className='text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center'
                        onClick={submitForm}
                        title="Gravar e continuar registro"
                        disabled={saveButtonDisable.value}
                    >
                        Avançar
                    </button>
                </div>
            )}
        >
            <Fragment>
                <Tab tabItems={tabItems} tabIndex={0}></Tab>
                <div id="tab-content" className="overflow-y-auto">
                    <IndividualFormTab1
                        key="tab1"
                        form={form.value}
                        errorFields={errorFields.value}
                        changeForm={changeForm}
                    />
                </div>
            </Fragment>

        </PageForm>
    );
};


export default IndividualPageForm;